export const portalEnvironment = {
  production: false,
  apiUrl: 'https://azfun-azuf-euw-d-nps-gitc.azurewebsites.net',
  authMember: {
    clientId: '287d8b2b-2b0b-480d-b9d0-d36e7b1d9bf1',
    authority: 'https://login.microsoftonline.com/common',
    scopes: ['openid']
  },
  authO365: {
    clientId: '6eee94ed-3821-4243-8d4f-075cc993b5d8',
    authority: 'https://login.microsoftonline.com/9f69edf3-ef71-467c-8885-5e380cdc20cd',
    scopes: ['api://6eee94ed-3821-4243-8d4f-075cc993b5d8/all']
  },
  appInsightsKey: ''
  //appInsightsKey: '450632d2-addf-42e2-9aec-d45f6c2938b3'
};
